import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { CorePopupComponent } from '../../../../../../../../ui-components/core-popup/core-popup.component';
import { ICasePatientAddress } from '../../../../../../interfaces/interfaces';
import { AppMessageService } from '../../../../../../../../shared/services/app-message/app-message.service';

@Component({
  selector: 'app-case-patient-address-popup',
  templateUrl: './case-patient-address-popup.component.html',
  styleUrl: './case-patient-address-popup.component.scss',
})
export class CasePatientAddressPopupComponent {
  addresses: ICasePatientAddress[];
  selectedPatientAddress: ICasePatientAddress | null;
  @Output() saveOn = new EventEmitter();
  @ViewChild('corePopup') corePopup: CorePopupComponent;

  constructor(private readonly messageService: AppMessageService) {}

  initilize(patientAddresses: ICasePatientAddress[]) {
    this.addresses = patientAddresses ?? [];
    this.corePopup.openDialog();
  }

  save() {
    if (!this.selectedPatientAddress) {
      this.messageService.warningToast('Bir adres seçilmeli', '');
      return;
    }
    this.saveOn.emit(this.selectedPatientAddress);
    this.selectedPatientAddress = null;
    this.corePopup.closeDialog();
  }
}
